<template>
  <qx-card-form title="归属">
    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="180px"
    >
    </qx-custom-form>
    <button @click="getDataTest" class="test-btn">测试提交参数</button>
  </qx-card-form>
</template>
<script>
import {
  getBaseUser,
  doQueryByOrgId, getSysCfgStr,
} from 'api/operate';
import {mapState} from 'vuex';
export default {
  data () {
    return {
      orderDefaultDept: false, // orderDefaultDept为true时，取线路的归属部门
      otherFormData: {
        localUserInfo: {},
      },
      baseForm: {
        orgIdOptions: [],
        inline: true,
        form: [
          {
            label: '跟单人员',
            value: 'localUserName',
            type: 'el-autocomplete',
            valueKey: 'linkman',
            placeholder: '请输入跟单人员姓名',
            hide: false,
            querySearchAsync: (queryString, cb) => {
              // cb 返回的是检索出来匹配的数组
              let resInfo = [];
              if (queryString && queryString.length) {
                // 如果修改了但是没选中新的，就清空相关的字段
                if (this.otherFormData.localUserInfo.linkman !== queryString) {
                  this.$refs.baseForm.setVal('localPhone', '');
                  this.$refs.baseForm.setVal('localUser', '');
                }
                doQueryByOrgId({ linkman: queryString }).then((res) => {
                  if (res && res.items) {
                    resInfo = res.items;
                  }
                  cb(resInfo);
                });
              }
              cb(resInfo);
            },
            onSelect: (item) => {
              this.otherFormData.localUserInfo = item;
              this.setBaseForm(this.otherFormData.localUserInfo);
            },
          },
          {
            label: '跟单手机',
            value: 'localPhone',
            type: 'input',
            readonly: true,
          },
          {
            label: '归属部门',
            value: 'orgId',
            type: 'select',
          },
          {
            label: '跟单人员id',
            value: 'localUser',
            type: 'input',
            readonly: true,
            hide: true,
          },
          {
            label: '司机是否隐藏跟单人员',
            value: 'visibleTrace',
            type: 'radio',
            default: 0,
            options: [
              { label: '是', value: 1 },
              { label: '否', value: 0 },
            ],
          },
        ],
        rules: {
          localUserName: [
            { required: true, message: '请输入跟单人员', trigger: 'blur' },
          ],
          localPhone: [
            { required: true, message: '请输入跟单手机', trigger: 'blur' },
          ],
        },
      },
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo, // 用户信息
    }),
  },
  methods: {
    async getDataTest () {
      this.sub();
    },
    setList (options) {
      this.baseForm.orgIdOptions = options;
    },
    async setData (data) {
      if (this.orderDefaultDept) {
        if (data) {
          const lineInfo = data.line;
          if (lineInfo.saleDaparment) {
            this.$refs.baseForm.setVal('orgId', Number(lineInfo.saleDaparment));
          }
        }
      }
    },
    setBaseForm (data) {
      this.setBelongForm(data);
      this.$emit('setVehicleStaffForm', data);
    },
    setBelongForm (data) {
      this.$refs.baseForm.setVal('localUserName', data.linkman || '');
      this.$refs.baseForm.setVal('localPhone', data.loginAcct || '');
      this.$refs.baseForm.setVal('localUser', data.userId || '');
    },
    // 获取订单的归属部门取当前登录人的还是线路的配置值
    async getSysCfgStr () {
      const res = await getSysCfgStr({
        cfgName: 'ORDER_DEFAULT_DEPT',
      });
      if (!res.failed) {
        let data = this.userInfo.staffTFInfo.tenantId;
        this.orderDefaultDept = !!(res.ORDER_DEFAULT_DEPT && res.ORDER_DEFAULT_DEPT.includes(data));
      }
    },
    // 登录用户基本信息
    async getBaseUser (isSetDefaultValue) {
      if (isSetDefaultValue) {
        const resBaseUser = await getBaseUser();
        if (!resBaseUser.failed) {
          this.otherFormData.localUserInfo = {
            linkman: resBaseUser.linkman,
            loginAcct: resBaseUser.loginAcct,
            userId: resBaseUser.userId,
          };
          this.$refs.baseForm.setVal({
            localUserName: resBaseUser.linkman,
            localPhone: resBaseUser.loginAcct,
            orgId: resBaseUser.orgId,
            localUser: resBaseUser.userId,
          });
          this.$emit('setVehicleStaffForm', this.otherFormData.localUserInfo);
        }
      }
    },
    async handleSubData (cache) {
      let formData = null;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      if (formData || cache) {
        // 这里处理的格式必须和详情接口返回的一样
        formData = {
          ...formData,
          ...this.otherFormData,
        };
      }
      return formData;
    },
    async cacheData () {
      const res = await this.handleSubData(true);
      return res;
    },
    async sub () {
      let formData = await this.handleSubData();
      if (formData) {
        let dispatchInfo = {};
        for (let name in formData) {
          if (formData[name] !== null && formData[name] !== undefined) {
            dispatchInfo['dispatchInfo.' + name] = formData[name];
          }
        }
        delete dispatchInfo['dispatchInfo.localUserInfo'];
        formData = dispatchInfo;
      }
      return formData;
    },
    setCacheAndDetailData (data) {
      if (data.orderGoods) {
        data.localUser = data.orderGoods.localUser;
        data.localPhone = data.orderGoods.localPhone;
        data.localUserName = data.orderGoods.localUserName;
        data.visibleTrace = data.orderGoods.visibleTrace;
      }
      if (data.orderInfo) {
        data.orgId = data.orderInfo.orgId;
      }
    },
    async init (data = {}) {
      this.$refs.baseForm.reset();
      this.setCacheAndDetailData(data);
      this.getBaseUser(!data.localUser);
      this.getSysCfgStr();
      this.$refs.baseForm.setVal(data);
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
